
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-layout.html
riot.tag2('menu-item-layout',
  '<i ref="layoutIcon" class="toolbar-icons layout-freehand {opts.classes} floating-menu_icon"></i> <span class="floating-menu_label">Layout</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg>',
  '',
  'class="{opts.classes} floating-menu_item" onmouseenter="{summonLayoutMenu}"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util');

var _menuUi = require('lib/menu-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _delayHandler = require('lib/delay-handler');

var _constants = require('lib/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parent = this.parent;

this.setDisplayedLayout = _menuUi.mui.setDisplayedLayout.bind(this);

this.summonLayoutMenu = function () {
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'layout',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this._summonLayoutMenu();
    }
  });
};

this._summonLayoutMenu = function () {
  parent.hideSubMenus();

  _menuUi.mui.canvas.nodeLayoutMenuTag.summon({
    referenceEl: _this.root,
    tag: parent.nodeTag,
    positionToLeft: parent.positionSubToLeft,
    origin: parent.menuName
  });

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(parent),
    action: 'Open-Layout-Menu',
    label: 'Layout'
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-layout')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-layout.html
// module id = 690
// module chunks = 0